import React, { useState, useEffect } from 'react';
import '../../CSS/Global.css';
// import Header from './Header';
// import Sidebar from './SideBar';
import ExpenseModal from './ExpenseModal';
import { useLocation } from 'react-router-dom';


// ✅ Toastify
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from '../Header';
import Sidebar from '../SideBar';
import { useSidebar } from '../../SidebarContext';
import Swal from 'sweetalert2';
import RecurringModal from './RecurringModal';

const Expenses = () => {
  const location = useLocation();
  const submittedData = location.state;
   const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh"));
  const [selectedExpense, setSelectedExpense] = useState(null);
  const [customers, setCustomers] = useState([]);
  const { isSidebarOpen } = useSidebar();
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredCustomers, setFilteredCustomers] = useState(customers);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const url=process.env.REACT_APP_LINK

  const fetchExpenses = async () => {
    try {
      const res = await fetch(`${url}/api/expenses/all/${isLoggedIn.user_id}`);
      const data = await res.json();
      const formattedData = data.map(item => ({ ...item, isEditing: false }));
      setCustomers(formattedData);
    } catch (err) {
      console.error("Failed to fetch expenses:", err);
    }
  };
  useEffect(() => {


    fetchExpenses();
  }, []);

  useEffect(() => {
    const filtered = customers.filter((customer) =>
      Object.values(customer).some((value) =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
    setFilteredCustomers(filtered);
    setCurrentPage(1);

    if (submittedData) {
      setCustomers(submittedData);
    }
  }, [searchQuery, customers, submittedData]);

  const totalPages = Math.ceil(filteredCustomers.length / itemsPerPage);
  const currentData = filteredCustomers.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleSearch = (e) => setSearchQuery(e.target.value);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleDelete = async (customerId) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await fetch(`${url}/api/expenses/${customerId}`, {
            method: 'DELETE',
          });
          if (!response.ok) {
            const err = await response.json();
            throw new Error(err?.message || 'Failed to delete');
          }

          Swal.fire('Deleted!', 'Customer has been deleted.', 'success');
          setCustomers((prev) => prev.filter((item) => item.id !== customerId));
        } catch (error) {
          console.error('Delete error:', error.message);
         Swal.fire('Error!', `Failed to delete customer. ${error.message}`, 'error');
        }
      }
    });



  };

  return (
    <>
      <Header />
      <Sidebar />
      <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
        <div className="oms-header">
          <h1 className="dashboard-title">Expenses</h1>
          <button className="oms-add-btn" onClick={() => setIsModalOpen(true)}>Add expense</button>
        </div>

        {/* Search Filter */}
        <div className="filter-search">
          <div className="filter-search-input">
            <input
              type="search"
              placeholder="Search..."
              value={searchQuery}
              onChange={handleSearch}
            />
            <i className="fa fa-search"></i>
          </div>
        </div>

        {/* Customer Table */}
        <div className="customer-table">
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Attach Receipt</th>
                <th>Category</th>
                <th>Amount</th>
                <th>Invoice No.</th>
                <th>Notes</th>
                <th>Customer</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentData.length > 0 ? (
                currentData.map((customer) => (
                  <tr key={customer.id}>
                    <td>{customer.date}</td>
                    <td>
                      <a
                        href={`${url}/Images/Expense/${customer.receipt}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View
                      </a>
                    </td>
                    <td>{customer.category}</td>
                    <td>{customer.amount}</td>
                    <td>{customer.invoiceNumber}</td>
                    <td>{customer.notes}</td>
                    <td>{customer.customer}</td>
                    <td>

                      <button
                        className="edit-btn"
                        onClick={() => {
                          setSelectedExpense(customer);
                          setIsModalOpen(true);
                        }}
                      >
                        <i className="fa-solid fa-pen"></i>
                      </button>
                      <button
                        onClick={() => handleDelete(customer.id)}
                        className="delete-btn"

                        style={{ marginLeft: '8px' }}
                      >
                        <i className="fa-solid fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" style={{ textAlign: 'center' }}>No data found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          {Array.from({ length: totalPages }, (_, index) => (
            <button
              key={index}
              onClick={() => paginate(index + 1)}
              className={currentPage === index + 1 ? 'active' : ''}
            >
              {index + 1}
            </button>
          ))}
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>

        {/* ✅ Toast Container */}
        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnHover
        />
      </div>

      {/* Expense Modal */}
      <ExpenseModal
        isOpen={isModalOpen}
        setIsOpen={(val) => {
          setIsModalOpen(val);
          if (!val) setSelectedExpense(null);
        }}
        editExpense={selectedExpense}
        fetchExpenses={fetchExpenses}
      />
    </>
  );
};

export default Expenses;